const offTime = {
  0: {
    name: 'Add Tour',
    authRule: ''
  },
  1: {
    name: 'Add Assignment',
    authRule: ''
  },
  2: {
    name: 'Notifications Log',
    authRule: ''
  },
  3: {
    name: 'Change Day Type',
    authRule: 'changeDayType'
  },
  4: {
    name: 'Add Days Off Request',
    authRule: ''
  },
  4: {
    name: 'Edit Days Off Request',
    authRule: 'editDayTypeRequest'
  }
};

export default offTime;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/context-menu-arrays/offTime.js